import { api } from '../axiosConfig';

export class InternalUserAPI {
    static async getInternalUsers() {
        const response = await api.post('/api/v1/auth/user/internal-users', {});
        return response.data;
    }

    static async createInternalUser(data: any) {
        const response = await api.post('/api/v1/auth/user/create-internal', data);
        return response.data;
    }

    static async updateInternalUser(id: string, data: any) {
        const response = await api.put(`/api/v1/auth/user/update-internal/${id}`, data);
        return response.data;
    }
}
